const PROFESSOR_TOKEN_KEY = 'lectureme_professor_token';
const STUDENT_TOKEN_KEY = 'lectureme_student_token';
const COOKIE_MAX_AGE_DAYS = 10;

function getCookie(name: string): string | null {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? decodeURIComponent(match[2]) : null;
}

function setCookie(name: string, value: string, maxAgeDays: number): void {
  const maxAge = maxAgeDays * 24 * 60 * 60;
  const secure = window.location.protocol === 'https:' ? '; Secure' : '';
  document.cookie = `${name}=${encodeURIComponent(value)}; path=/; max-age=${maxAge}; SameSite=Lax${secure}`;
}

function clearCookie(name: string): void {
  document.cookie = `${name}=; path=/; max-age=0`;
}

export function getProfessorToken(): string | null {
  return getCookie(PROFESSOR_TOKEN_KEY);
}

export function setProfessorToken(token: string): void {
  setCookie(PROFESSOR_TOKEN_KEY, token, COOKIE_MAX_AGE_DAYS);
}

export function clearProfessorToken(): void {
  clearCookie(PROFESSOR_TOKEN_KEY);
}

export function getStudentToken(): string | null {
  return getCookie(STUDENT_TOKEN_KEY);
}

export function setStudentToken(token: string): void {
  setCookie(STUDENT_TOKEN_KEY, token, COOKIE_MAX_AGE_DAYS);
}

export function clearStudentToken(): void {
  clearCookie(STUDENT_TOKEN_KEY);
}
